import http from '../../../services/api'
import type { APIResponse } from '../../../services/types'
import type {
  BusinessCategoryApi,
  BusinessRegistrationPayload,
  BusinessRegistrationResponse,
  BusinessTypeApi,
  RegisteredBusinessApi,
} from '../types'

const apiPath = import.meta.env.VITE_API_PATH
const basePath = `${apiPath}business`

async function getBusinessCategories() {
  return await http.get<BusinessCategoryApi[]>(`${basePath}/category`)
}

async function getBusinessTypes(businessCategoryId?: number) {
  const params =
    businessCategoryId != null ? `?business_category_id=${encodeURIComponent(String(businessCategoryId))}` : ''
  return await http.get<BusinessTypeApi[]>(`${basePath}/type${params}`)
}

async function registerBusiness(payload: BusinessRegistrationPayload) {
  return await http.post<BusinessRegistrationResponse>(basePath, payload)
}

const businessRegistrationService = {
  getBusinessCategories,
  getBusinessTypes,
  registerBusiness,
}

export type { APIResponse, RegisteredBusinessApi }
export default businessRegistrationService
